import React from 'react';
import { CardBase } from '@icarros/ids-react';
import { CardWrapper } from './style';
import { Incomplete } from './Incomplete';
import { Active } from './Active';
import { Analyzing } from './Analyzing';
import { Waiting } from './Waiting';
import { Expired } from './Expired';
import { Deactivated } from './Deactivated';
import { CardProps } from './constants';
import { STATUS } from '../../../../enum/listing-status';

export function Card({ card, ...rest }: CardProps): JSX.Element {
  return (
    <CardWrapper>
      <CardBase variant="default" hasHover={false} selected={false} {...rest}>
        {card.filterName === STATUS.incomplete && <Incomplete card={card} />}
        {card.filterName === STATUS.active && <Active card={card} />}
        {card.filterName === STATUS.analyzing && <Analyzing card={card} />}
        {card.filterName === STATUS.waiting && <Waiting card={card} />}
        {card.filterName === STATUS.expired && <Expired card={card} />}
        {card.filterName === STATUS.deactivated && <Deactivated card={card} />}
      </CardBase>
    </CardWrapper>
  );
}
